module.exports = __webpack_public_path__ + "img/warning.d3868276.svg";